export var TeamMemberSkillLGSF;
(function (TeamMemberSkillLGSF) {
    TeamMemberSkillLGSF["Construction"] = "CONSTRUCTION";
    TeamMemberSkillLGSF["LowDoc"] = "LOW_DOC";
    TeamMemberSkillLGSF["NonConformingLoan"] = "NON_CONFORMING_LOAN";
    TeamMemberSkillLGSF["Guarantor"] = "GUARANTOR";
    TeamMemberSkillLGSF["SelfEmployed"] = "SELF_EMPLOYED";
    TeamMemberSkillLGSF["TopUps"] = "TOP_UPS";
    TeamMemberSkillLGSF["Bridging"] = "BRIDGING";
    TeamMemberSkillLGSF["Trust"] = "TRUST";
    TeamMemberSkillLGSF["Commercial"] = "COMMERCIAL";
})(TeamMemberSkillLGSF || (TeamMemberSkillLGSF = {}));
export var TeamMemberSkillLGSFWithLabel = {
    Construction: {
        value: 'CONSTRUCTION',
        label: 'Construction',
    },
    LowDoc: {
        value: 'LOW_DOC',
        label: 'Low Doc',
    },
    NonConformingLoan: {
        value: 'NON_CONFORMING_LOAN',
        label: 'Non Conforming Loan',
    },
    Guarantor: {
        value: 'GUARANTOR',
        label: 'Guarantor',
    },
    SelfEmployed: {
        value: 'SELF_EMPLOYED',
        label: 'Self employed',
    },
    TopUps: {
        value: 'TOP_UPS',
        label: 'Top ups',
    },
    Bridging: {
        value: 'BRIDGING',
        label: 'Bridging',
    },
    Trust: {
        value: 'TRUST',
        label: 'Trust',
    },
    Commercial: {
        value: 'COMMERCIAL',
        label: 'Commercial',
    },
};
//# sourceMappingURL=TeamMemberSkillLGSF.js.map